import React, { useState, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { Layout, ConfigProvider, theme } from 'antd';
import { useLocation, useSearchParams } from 'react-router-dom';
import {  customLightTheme, customLightMuiTheme,
          customDarkTheme, customDarkMuiTheme
} from "./themeConfig";
import {PublicRoutes} from "./configs/AppRoutes";
import { AuthContext } from './contexts/AuthContext';
import {ThemeProvider} from "@mui/material/styles";
import Disclaimer from "./components/Disclaimer";
import EntryPortal from "./pages/Entry/EntryPortal";
import Frame from "./layouts/Frame";
import ErrorBoundary from "./layouts/ErrorBoundary";


const IAPlatformApp = ({keys})=>{

    return (
        <ConfigProvider theme={customLightTheme}>
            <ThemeProvider theme={customLightMuiTheme}>
                <Frame keys={keys} />
            </ThemeProvider>
        </ConfigProvider>
    )
}


const PublicApp = ()=>{
    return (
        <ConfigProvider theme={customLightTheme}>
            <ThemeProvider theme={customLightMuiTheme}>
                <PublicRoutes />
            </ThemeProvider>
        </ConfigProvider>
    )
}


const BrandedHelmet = ({title})=>{
    return (
        <Helmet>
            <link rel={'icon'} href={'https://storage.googleapis.com/finiat-web-static-resources/company-brands/finiat-f-black.ico'} />
            <title>{title}</title>
        </Helmet>
    )
}


function App() {
    const { isLoggedIn } = useContext(AuthContext);
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const [collapsed, setCollapsed] = useState(true); // State to control the collapse
    const [agreementConfirmed, setAgreementConirmed] = useState(false);
    const accountType = localStorage.getItem('acct_type');
    const isPublicRoute = location.pathname.startsWith('/public');
    const userApps = localStorage.getItem('apps');


    if (isPublicRoute) {
        return <PublicApp />
    }

    if (!isLoggedIn) {
        return (
            <>
                <BrandedHelmet title={'IA Login'} />

                <EntryPortal
                    initialView={searchParams.get('setView')}
                    prospect={searchParams.has('isProspect')}
                />
            </>
        )
    }


    const handleAgreement = () => {
        setAgreementConirmed(true);
    };

    if (!agreementConfirmed) {
        return (
        <ConfigProvider theme={customLightTheme}>
            <ThemeProvider theme={customLightMuiTheme}>
                <BrandedHelmet title={'FINIAT Disclaimer'} />
                <Disclaimer onAgree={handleAgreement} />
            </ThemeProvider>
        </ConfigProvider>
        );
    }

    return (
        <>
            <BrandedHelmet title={'Finiat'} />
            <ErrorBoundary>
                {accountType === 'platform' && <IAPlatformApp {...{collapsed, setCollapsed}} keys={userApps} />}
            </ErrorBoundary>
        </>
    );
}

export default App;
